// extracted by mini-css-extract-plugin
export default {"root":"style_root__B73KV","data":"style_data__rwQjk","address":"style_address__KzjRk","submit":"style_submit__hXGdV"};